import { validateConnectionPointClaim, validateSmartboxClaim } from "../scripts/api_v2/crm_client";

export const Form_validators_enum = Object.freeze({
  VALIDATE_REQUIRED: (attr_name) => ({
    isAsync: () => false,
    validate: (value) => !!value,
    getMessage: () => `${attr_name} is required`,
  }),
  VALIDATE_STARTS_WITH: (attr_name, starts_with) => ({
    isAsync: () => false,
    validate: (value) => typeof value === "string" && value.startsWith(starts_with),
    getMessage: () => `${attr_name} should start with ${starts_with}`,
  }),
  VALIDATE_FIXED_LENGTH: (attr_name, required_length) => ({
    isAsync: () => false,
    validate: (value) => value && value.length === required_length,
    getMessage: () => `${attr_name} should be ${required_length} characters long`,
  }),
  VALIDATE_ALPHA_NUMERIC: (attr_name) => ({
    isAsync: () => false,
    validate: (value) => /^[a-zA-Z0-9]+$/.test(value),
    getMessage: () => `${attr_name} should only consist of alpha numeric characters`,
  }),
  VALIDATE_NUMERIC: (attr_name) => ({
    isAsync: () => false,
    validate: (value) => /^[0-9]+$/.test(value),
    getMessage: () => `${attr_name} should only consist of numeric characters`,
  }),
  VALIDATE_ALPHA_NUMERIC_SPACE_AND_UNDERSCORES: (attr_name) => ({
    isAsync: () => false,
    validate: (value) => /^[a-zA-Z0-9 _-]+$/.test(value),
    getMessage: () => `${attr_name} should only consist of alpha numeric characters, spaces or underscores`,
  }),
  VALIDATE_MIN_LENGTH: (attr_name, min_length) => ({
    isAsync: () => false,
    validate: (value) => value && value.length >= min_length,
    getMessage: () => `${attr_name} should contain at least ${min_length} characters`,
  }),
  VALIDATE_MAX_LENGTH: (attr_name, max_length) => ({
    isAsync: () => false,
    validate: (value) => value && value.length <= max_length,
    getMessage: () => `${attr_name} should contain max ${max_length} characters`,
  }),
  VALIDATE_SMARTBOX_CLAIM: (attr_name) => ({
    isAsync: () => true,
    validate: async (backend, value) => validateSmartboxClaim(backend.fetch, value),
    getMessage: () => `${attr_name} can not be claimed`,
  }),
  VALIDATE_CONNECTION_POINT_CLAIM: (attr_name) => ({
    isAsync: () => true,
    validate: async (backend, value) => validateConnectionPointClaim(backend.fetch, value),
    getMessage: () => `${attr_name} can not be claimed`,
  }),
});

export function generateInitialFormValidity(formConfig, setValidityResults) {
  let validityResults = {};

  for (const fieldName of Object.keys(formConfig)) {
    const fieldConfig = formConfig[fieldName];
    const defaultValue = formConfig[fieldName].defaultValue;
    if (fieldConfig.validators && fieldConfig.isRequired) {
      for (const validator of fieldConfig.validators) {
        let isValid = false;
        if (!validator.isAsync()) {
          isValid = validator.validate(defaultValue);
        } else {
          // skipping async calls for initial validity
        }
        // Set the validity state for the field
        validityResults[fieldName] = {
          isValid: isValid,
          errorMsg: validator.getMessage(),
        };

        if (!isValid) {
          break; // Stop checking other validators if one is invalid
        }
      }
    }
  }
  setValidityResults(validityResults);
}

export async function validateForm(fieldName, fieldValue, formConfig, setValidityResults, backend) {
  // check if we have config + validator for this field
  if (formConfig[fieldName] && formConfig[fieldName].validators) {
    let isValid = true;
    let msg = "";
    // handle validation for optional fields and fields with content
    if (formConfig[fieldName].isRequired || (!formConfig[fieldName].isRequired && fieldValue)) {
      for (const validator of formConfig[fieldName].validators) {
        if (validator.isAsync()) {
          isValid = await validator.validate(backend, fieldValue);
        } else {
          isValid = validator.validate(fieldValue);
        }
        if (!isValid) {
          msg = validator.getMessage();
          // Skip extra Results if we have one invalid > avoid doing unnecessary backend calls
          break;
        }
      }
    }

    setValidityResults((prevState) => ({
      ...prevState,
      [fieldName]: {
        isValid: isValid,
        errorMsg: msg,
      },
    }));
  }
}
